//Home.jsx
// Import required components and assets
import React from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi'; // Arrow icon for button
import me from '../assets/me.png'; // Your profile photo
import image from '../assets/image.webp'; // Your profile photo
import { Link } from "react-scroll"; // For smooth scrolling
import { motion } from 'framer-motion';
import { styles } from '../styles';
import { SectionWrapper } from '../hoc';
import { fadeIn, textVariant } from '../utils/motion';

const Home = () => {
  return null;
};

export default SectionWrapper(Home, "home");
